import { NavLink, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { setCityName, setModelSize } from "../features/modelSlice";
import { setDetectionImage, setInferenceTime } from "../features/detectSlice";
import { setLogout } from "../features/authSlice";

import style from "./Header.module.css";
import { useEffect} from "react";
import useModel from "../hooks/useModel";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    token,
    user: { role, city: userCity },
  } = useSelector((state) => state.auth);
  // console.log(role,userCity);
  // const role = user?.role || null; // Get the role from the user object
  // const userCity = user?.city || null; // Get the city from the user object
  const { cityName, modelSize } = useSelector((state) => state.model);
  // const hasSetCity = useRef(false); // Track if the city has been set
  useEffect(() => {
    // console.log("Header useEffect triggered");
    if (userCity === "all") {
      dispatch(setCityName("Tarragona"));
      return; // No need to update if the city is already set
    }
    dispatch(setCityName(userCity));
  }, [userCity, dispatch]);
  
  useModel(cityName, modelSize); // Load the model when city or model size changes
  function handleCityChange(e) {
    dispatch(setCityName(e.target.value));
    dispatch(setDetectionImage(null)); // Reset the processed image
    dispatch(setInferenceTime(0)); // Reset the inference time
  }
  function handelModelSizeChange(e) {
    dispatch(setModelSize(e.target.value));
    dispatch(setDetectionImage(null)); // Reset the processed image
    dispatch(setInferenceTime(0)); // Reset the inference time
  }

  return (
    <div className={style.header}>
      <div className={style.top}>
        <NavLink to="/" end>
          <div className={style.logo}>
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="logo" />
            <h1>Smart City System</h1>
          </div>
        </NavLink>
        {role === "admin" && (
          <nav className={style.nav}>
            <NavLink to="/image-detection" end>
              Image Detection
            </NavLink>
            <NavLink to="/live-detection">Live Detection</NavLink>
            <NavLink to="/data-collection">Data Collection</NavLink>
            <NavLink to="/map-results">Map Results</NavLink>
          </nav>
        )}
        {role === "manager" && (
          <nav className={style.nav}>
            <NavLink to="/data-collection">Data Collection</NavLink>
            <NavLink to="/map-results">Map Results</NavLink>
          </nav>
        )}
        {token && (
          <button
            className={style.logoutBtn}
            onClick={() => {
              dispatch(setLogout());
              navigate("/login");
            }}
          >
            {role ? `Logout as ${role}` : "Logout"}
          </button>
        )}
      </div>
      {role === "admin" && (
        <div className={style.citySelectBtn}>
          <h3>Select City and Model Size</h3>
          <select
            className={style.citySelect} // Replace with your style class
            value={cityName} // Controlled component
            onChange={handleCityChange}
          >
            <option value="Tarragona">Tarragona</option>
            <option value="Reus">Reus</option>
            <option value="Lleida">Lleida</option>
          </select>
          <select
            className={style.modelSelect} // Replace with your style class
            value={modelSize} // Controlled component
            onChange={handelModelSizeChange}
          >
            <option value="yolo11n">Nano Model</option>
            <option value="yolo11s">Small Model</option>
            <option value="yolo11m">Medium Model</option>
            <option value="yolo11l">Large Model</option>
          </select>
        </div>
      )}
    </div>
  );
}

export default Header;
